function parsePossiblyJson(value) {
  if (typeof value !== "string") {
    return value;
  }

  try {
    return JSON.parse(value);
  } catch (error) {
    return value;
  }
}

/**
 * Normalize analysis details payload from the backend into
 * `{ chart, drawnObjectsOptions }`.
 */
export default function normalizeChartAnalysisDetails(raw) {
  let data = parsePossiblyJson(raw);

  if (!data || typeof data !== "object") {
    throw new Error("Invalid analysis details");
  }

  if (data.settings != null) {
    const settings = parsePossiblyJson(data.settings);
    if (settings && typeof settings === "object") {
      data = {
        ...data,
        ...settings,
        chart: settings.chart != null ? settings.chart : data.chart,
        drawnObjectsOptions:
          settings.drawnObjectsOptions ||
          settings.settings ||
          data.drawnObjectsOptions
      };
    }
  }

  const chart = parsePossiblyJson(data.chart);
  if (!chart) {
    throw new Error("Analysis chart missing");
  }

  return {
    chart,
    drawnObjectsOptions: Array.isArray(data.drawnObjectsOptions)
      ? data.drawnObjectsOptions
      : Array.isArray(data.settings)
        ? data.settings
        : []
  };
}
